// startup
// Load entry module
__webpack_require__("./components/03-organisms/banners/banner-carousel.js");
// This entry module used 'exports' so it can't be inlined
